module.exports = __webpack_public_path__ + "fontawesome-webfont.acf3dcb7ff752b5296ca.svg";


//////////////////
// WEBPACK FOOTER
// C:/Users/oggy.yuristantyo/source/Workspaces/UI_SBN_Ritel_Web/src/fonts/fontawesome-webfont.svg?v=4.7.0
// module id = ../../../../../src/fonts/fontawesome-webfont.svg?v=4.7.0
// module chunks = 2